import { useRef } from 'react';
import { Footer } from 'remote-com-shared/components/Footer';
import HeaderContext from 'remote-com-shared/components/Header/context';
import { NavigationMenu } from 'remote-com-shared/components/HeaderNavigation/NavigationMenu';
import HeroContext, { useHeroIntersection } from 'remote-com-shared/components/Hero/context';

import { Banner } from '@/src/components/Banner/Banner';
import { hasBanner } from '@/src/components/Banner/helpers';
import { Header } from '@/src/components/Header';
import { transformProperties } from '@/src/domains/prismic/helpers';

const DefaultLayout = ({ sharedServices, children }) => {
  const headerRef = useRef();
  const heroIntersection = useHeroIntersection();
  const { bannerSitewide, headerNavigationSitewide, footerNavigationSitewide } =
    sharedServices ?? {};
  const bannerProps = transformProperties(bannerSitewide);
  const { description } = bannerProps ?? {};

  return (
    <HeroContext.Provider value={heroIntersection}>
      <HeaderContext.Provider value={headerRef}>
        {hasBanner(description) ? <Banner {...bannerProps} /> : null}
        <Header ref={headerRef}>
          <NavigationMenu {...headerNavigationSitewide} />
        </Header>
        {children}
        <Footer {...footerNavigationSitewide} />
      </HeaderContext.Provider>
    </HeroContext.Provider>
  );
};

export default DefaultLayout;
